export const API_URL = 'https://rpc.walletconnect.org/v1/json-rpc';
//# sourceMappingURL=ConstantsUtil.js.map